module.exports = __webpack_public_path__ + "static/scale-model-of-raymond-theatre-in-pasadena-california-a04a573242f362a971b3e43909b2a4fd.png";